// Event Bus Global Event Types
export var EventTypes;
(function (EventTypes) {
    // CDP Events
    EventTypes["CDPIdentify"] = "CDP Identify";
    EventTypes["CDPGroup"] = "CDP Group";
    EventTypes["CDPTrack"] = "CDP Track";
    // Billing
    EventTypes["PlanTypeEdited"] = "Plan Type Edited";
    EventTypes["SubscriptionStatusEdited"] = "Subscription Status Edited";
    EventTypes["InitialSubscriptionDateEdited"] = "Initial Subscription Date Edited";
    EventTypes["SubscriptionTermEdited"] = "Subscription Term Edited";
    EventTypes["BillingCycleEdited"] = "Billing Cycle Edited";
    EventTypes["PaymentTermDayEdited"] = "Payment Term Day Edited";
    EventTypes["PaymentTermContextEdited"] = "Payment Term Context Edited";
    EventTypes["PaymentMethodEdited"] = "Payment Method Edited";
    EventTypes["CurrencyEdited"] = "Currency Edited";
})(EventTypes || (EventTypes = {}));
// Customer Data Platform (Segment) Event type
export var CDPEventTypes;
(function (CDPEventTypes) {
    CDPEventTypes["Identify"] = "identify";
    CDPEventTypes["Group"] = "group";
    CDPEventTypes["Track"] = "track";
    CDPEventTypes["Page"] = "page";
    CDPEventTypes["Alias"] = "alias";
    CDPEventTypes["Screen"] = "screen";
})(CDPEventTypes || (CDPEventTypes = {}));
